// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBar-module__ui-ProgressBar--aKsvc {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
}

.ProgressBar-module__box--C9HSw {
  width: 100%;
  height: 4px;
  overflow: hidden;
  border-radius: 2px;
  background-color: #eee;
}

.ProgressBar-module__bar--j7RCe {
  width: 2px;
  height: 100%;
  border-radius: inherit;
  background-color: #1a1a1a;
}

.ProgressBar-module__header--URP5U {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
}

.ProgressBar-module__header--URP5U:has(.ProgressBar-module__title--uyFhC) {
  order: -1;
  justify-content: space-between;
}

.ProgressBar-module__ui-ProgressBar--aKsvc:has(.ProgressBar-module__title--uyFhC) {
  gap: 8px;
}

.ProgressBar-module__ui-ProgressBar--aKsvc:has(.ProgressBar-module__title--uyFhC) .ProgressBar-module__box--C9HSw {
  height: 6px;
  background-color: #e8e2d9;
}

.ProgressBar-module__title--uyFhC {
  padding-bottom: 2px;
  color: #1a1a1a;
  font-size: 1rem; /* 16px */
  font-weight: 600;
  line-height: 1.1429;
}

.ProgressBar-module__label--kemc4 {
  display: block;
  padding-bottom: 1px;
  color: #666;
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  word-break: break-word;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/ProgressBar/ProgressBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":[".ui-ProgressBar {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.box {\n  width: 100%;\n  height: 4px;\n  overflow: hidden;\n  border-radius: 2px;\n  background-color: #eee;\n}\n\n.bar {\n  width: 2px;\n  height: 100%;\n  border-radius: inherit;\n  background-color: #1a1a1a;\n}\n\n.header {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.header:has(.title) {\n  order: -1;\n  justify-content: space-between;\n}\n\n.ui-ProgressBar:has(.title) {\n  gap: 8px;\n}\n\n.ui-ProgressBar:has(.title) .box {\n  height: 6px;\n  background-color: #e8e2d9;\n}\n\n.title {\n  padding-bottom: 2px;\n  color: #1a1a1a;\n  font-size: 1rem; /* 16px */\n  font-weight: 600;\n  line-height: 1.1429;\n}\n\n.label {\n  display: block;\n  padding-bottom: 1px;\n  color: #666;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n  line-height: normal;\n  white-space: nowrap;\n  word-break: break-word;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-ProgressBar": `ProgressBar-module__ui-ProgressBar--aKsvc`,
	"box": `ProgressBar-module__box--C9HSw`,
	"bar": `ProgressBar-module__bar--j7RCe`,
	"header": `ProgressBar-module__header--URP5U`,
	"title": `ProgressBar-module__title--uyFhC`,
	"label": `ProgressBar-module__label--kemc4`
};
export default ___CSS_LOADER_EXPORT___;
